import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Form from "../components/form";
import ProductPreview from "../components/productPreview";
import useButtonTracking from "../hooks/useButtonTracking";

const Subscribe = () => {
  const { t } = useTranslation();
  const [policyImpression] = useButtonTracking({
    text: "Privacy policy",
    placement: "left",
    targetpath: "/en_us/legal/privacy_policy.html",
  });

  return (
    <div className="grid grid-cols-12 gap-4">
      {/* Left side */}
      <div className="col-span-12 sm:col-span-5 flex flex-col justify-between">
        <div>
          <Dialog.Title
            as="h2"
            className="text-2xl font-bold tracking-wide text-gray-900 uppercase"
          >
            {t("Drop a hint")}
          </Dialog.Title>
          <Dialog.Description className="text-lg text-gray-900">
            {t("Get your perfect gift this season.")}
          </Dialog.Description>
        </div>
        <ProductPreview />
        <div {...policyImpression} className="text-xs font-semibold">
          <a
            href="/en_us/legal/privacy_policy.html"
            className="underline text-gray-900"
          >
            Privacy policy
          </a>
          .
        </div>
      </div>

      {/* Right side */}
      <div className="col-span-12 sm:col-span-7">
        <Form />
      </div>
    </div>
  );
};

export default Subscribe;
